import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4} from "../../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {useSearchParams} from "react-router-dom";
import {Card, Col, Row} from "reactstrap";
import AtAGlance from "../../../../components/AtAGlance";
import ColumnChart from "../../../../components/ColumnChart";
import PieChart from "../../../../components/PieChart";
import {snakeCaseToTitleCase} from "../../../../utils/Helpers";
import Grid from "../../../../components/Grid";
import {switchSummaryDefs} from "../../../../utils/gridColumnDefs/switches/switchSummary";
import {genericColors} from "../../../../utils/chartUtils";

const portSpeeds = ["1G", "2G", "4G", "8G", "16G", "32G", "OtherSpeed"];
const portErrors = ['Port Latency', 'BB Credit Zero RX Warning', 'BB Credit Zero TX Warning', 'Slow Drain Device', 'Class 3 Discard', 'Loss Of Sync Signal', 'Link Reset', 'Frame Too Long Short', 'CRC Errors', 'Link Failure'];

const switchSummaryAag = [
    {
        field: "global_name",
        mobile: true,
    },
    {
        field: "fabric",
        mobile: true,
    },
    {
        field: "os_version",
        mobile: true,
    },
    {
        field: "total_ports",
        // diff: true,
        mobile: true,
    },
];

export default function SwitchSummary({context, title}) {
    const [searchParams] = useSearchParams();
    const switchName = decodeURIComponent(searchParams.get('switch_name') || 'N/A');

    useTitleFromComponent(`${switchName} ${context} / ${title}`);

    const { theme, client, periodId } = useVsiAppContext();

    const [{recordsets}] = useDataWithRoute(`/api/v6/report/switch_summary_proc?client_id=${client.clientId}&period_id=${periodId}&switch_name=${encodeURIComponent(searchParams.get("switch_name"))}`)
    const [portsBySpeedData, setPortsBySpeedData] = useState({
        categories: portSpeeds,
        series: []
    });
    const [portsErrorsData, setPortErrorsData] = useState({
        categories: portErrors,
        series: []
    });
    const [pieData, setPieData] = useState([{
        name: '',
        data: []
    }]);

    let [pieRecords, barSpeedsRecords, gridRecords] = recordsets;

    const mungePie = data => {
        const keys = ['fc_free_licensed', 'fc_used_licensed'];

        return keys.map(key => ({
            name: snakeCaseToTitleCase(key.replace("fc_", "").replace("_licensed", "")),
            y: data[key]
        }));
    };

    const mungePortsSpeed = data => {
        const speedRef = {};
        data?.forEach(datum => {
            if (portSpeeds.includes(datum.port_speed_name)) {
                speedRef[datum.port_speed_name] = datum.port_speed;
            }
        });
        return [{
            name: 'Speed',
            data: portSpeeds.map((speed, i) => ({
                y: parseInt(speedRef?.[speed] ?? 0),
                color: genericColors?.[i] ?? genericColors?.[i - data.length + 1],
            }))
        }];
    }

    const mungeErrors = data => {
        return [{
            name: "Errors",
            data: portErrors.map((portErr, i) => (
                {
                    color: genericColors?.[i] ?? genericColors?.[i - data.length + 1],
                    y: parseInt(data?.[portErr.toLowerCase().split(" ").join("_")] ?? 0),
                }))
        }]
    }

    useEffect(() => {
        setPieData({
            name: '',
            data: mungePie(pieRecords?.[0] ?? {}),
        });

        setPortErrorsData({
            categories: portErrors,
            series: mungeErrors(pieRecords?.[0] ?? {}),
        });

    }, [pieRecords]);

    useEffect(() => {
        setPortsBySpeedData({
            categories: portSpeeds,
            series: mungePortsSpeed(barSpeedsRecords),
        });

    }, [barSpeedsRecords]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Switch Summary - {switchName}</VsiH4>
        <VsiBubble>
            <AtAGlance data={recordsets?.[0]?.[0] ?? []}
                       config={switchSummaryAag}
                       size={"lg"}/>
        </VsiBubble>
        <Row>
            <Col xs={12} lg={4}>
                <VsiBubble autobotName='BySpeedColumnChart'>
                    <ColumnChart categories={portsBySpeedData.categories}
                                 yAxisTitle={"Speed"}
                                 title={"Ports by Speed"}
                                 disableLegend={true}
                                 series={portsBySpeedData.series}/>
                </VsiBubble>
            </Col>
            <Col xs={12} lg={4}>
                <VsiBubble>
                    <PieChart
                        title={"% Ports Used"}
                        series={pieData}
                        includeLegend={true}/>
                </VsiBubble>
            </Col>
            <Col xs={12} lg={4}>
                <VsiBubble autobotName='ErrorsColumnChart'>
                    <ColumnChart categories={portsErrorsData.categories}
                                 title={"Port Errors"}
                                 yAxisTitle={"# of Errors"}
                                 disableLegend={true}
                                 series={portsErrorsData.series}/>
                </VsiBubble>
            </Col>
        </Row>
        <VsiBubble>
            <Grid data={gridRecords} columnDefs={switchSummaryDefs}/>
        </VsiBubble>
    </Card>
}
